"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Legend = exports.Label = exports.Fieldset = exports.FieldLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var Label = /*#__PURE__*/_styledComponents["default"].label.withConfig({
  displayName: "Form__Label",
  componentId: "sc-51v99l-0"
})(["display:block;width:max-content;margin-bottom:", ";margin-top:", ";word-break:keep-all;color:", ";cursor:pointer;"], function (p) {
  return p.theme.tokens.spacing01;
}, function (p) {
  return p.theme.tokens.spacing06;
}, function (p) {
  return p.theme.colorTextInputLabel;
});

exports.Label = Label;

var Fieldset = /*#__PURE__*/_styledComponents["default"].fieldset.withConfig({
  displayName: "Form__Fieldset",
  componentId: "sc-51v99l-1"
})(["padding:0 0 3rem 0;border:0 none;"]);

exports.Fieldset = Fieldset;

var Legend = /*#__PURE__*/_styledComponents["default"].legend.withConfig({
  displayName: "Form__Legend",
  componentId: "sc-51v99l-2"
})(["margin:0;font-weight:", ";font-size:", ";line-height:", ";"], function (p) {
  return p.theme.tokens.fontWeightBold;
}, function (p) {
  return p.theme.tokens.fontSizeLarge;
}, function (p) {
  return p.theme.tokens.lineHeightHeading;
});

exports.Legend = Legend;

var BlockSpan = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  displayName: "Form__BlockSpan",
  componentId: "sc-51v99l-3"
})(["display:block;"]);

var FieldLabel = function FieldLabel(_ref) {
  var label = _ref.label,
      small = _ref.small;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(BlockSpan, null, label), small && /*#__PURE__*/_react["default"].createElement("small", null, small));
};

exports.FieldLabel = FieldLabel;
FieldLabel.propTypes = {
  label: _propTypes.string.isRequired,
  small: _propTypes.string
};